<template>
  <v-list-item
		:three-line="!!(item.esposa && item.esposa.profissao)"
		:two-line="!(item.esposa && item.esposa.profissao)"
		@click="onClickItemBusca"
	>
		<v-list-item-avatar>
      <v-icon v-text="'mdi-face-woman'"/>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">{{ item.esposa && item.esposa.nome }}</v-list-item-title>
      <v-list-item-subtitle v-if="item.esposa && item.esposa.profissao"> {{ item.esposa.profissao }}</v-list-item-subtitle>
      <v-list-item-subtitle> Esposa de {{ item.nomeCompleto }} </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import Irmao from '../../../../common/types/Irmao'
import { adicionarBuscaRecente } from '@/shareds/buscasRecentes'
import { ResultadoBusca } from '../../../../common/types/Busca'
import { useRouter } from '@/composables/router'

const props = defineProps({
	item: { type: Object as PropType<Irmao>, required: true },
})

const router = useRouter()

function onClickItemBusca() {
	adicionarBuscaRecente(props.item as unknown as ResultadoBusca)
	router.push({
		name: 'detalhar-irmao',
		params: { id: props.item._id },
	})
}
</script>
